const CustomInput = ({...props}) => {
    
    return ( 
        <input {...props} className="w-full outline-none m-auto bg-main-01 p-2 font-medium text-sm text-gray-400 focus:bg-sides-01 focus:text-gray-300 rounded-md" />
     );
}
 
export default CustomInput;